import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, ShopButtonClickedTrackingEvent, TrackingEventName } from "./tracking";

interface TrackShopButtonClickedFunctionArgs {
  readonly buttonId: string;
  readonly userType?: string;
}

interface TrackShopButtonClickedFunction {
  (args: TrackShopButtonClickedFunctionArgs): void;
}

interface UseTrackShopButtonClickedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackShopButtonClickedFunction {
  (agrs: UseTrackShopButtonClickedFunctionArgs): TrackShopButtonClickedFunction;
}

const useTrackShopButtonClicked: UseTrackShopButtonClickedFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<ShopButtonClickedTrackingEvent>();

  const trackShopButtonClicked: TrackShopButtonClickedFunction = useCallback(
    ({ buttonId, userType }) => {
      emitUserEvent({
        event: TrackingEventName.SHOP_BUTTON_CLICKED,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        button: buttonId,
        userType,
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackShopButtonClicked;
};

export { useTrackShopButtonClicked };
